module.exports = __webpack_public_path__ + "img/336EB3_152578_A4C5E2_74AED9-256px.190dd1c7.png";